import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=b5d39e8e&scoped=true"
import script from "./Company.vue?vue&type=script&setup=true&lang=js"
export * from "./Company.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Company.vue?vue&type=style&index=0&id=b5d39e8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d39e8e",
  null
  
)

export default component.exports